import { useState, useEffect, useRef } from 'react'

interface ScrollState {
  isScrolling: boolean
}

function useScrollDetector(): ScrollState {
  const [isScrolling, setIsScrolling] = useState(false)

  useEffect(() => {
    let scrollingTimeout: number | null = null

    function handleScroll() {
      const currentScrollPosition = window.scrollY
      if (currentScrollPosition <= 0) return

      setIsScrolling(true)

      // Set isScrolling to false after a timeout
      if (!scrollingTimeout) {
        scrollingTimeout = window.setTimeout(() => {
          setIsScrolling(false)
          scrollingTimeout = null
        }, 1000) // Adjust this value to control the delay before isScrolling becomes false
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (scrollingTimeout) {
        clearTimeout(scrollingTimeout)
      }
    }
  }, [])

  return { isScrolling }
}

export default useScrollDetector
